var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isAPIOnline)?_c('div',[_c('hi-header'),_c('q-page-container',[_c('q-page',[_c('router-view')],1)],1),_c('hi-footer')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }